"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstWithSameLanguage = exports.mapJsonToTransformationFileName = exports.DefaultCallbackHandler = exports.createDefaultCallbackHandler = exports.lookup = exports.createClient = void 0;
var ajv_1 = __importDefault(require("ajv"));
var ajv_formats_1 = __importDefault(require("ajv-formats"));
var object_unpacker_1 = require("object-unpacker");
var context_1 = require("./context");
var dnsclient_1 = require("./dnsclient");
var dnsservices_1 = require("./dnsservices");
var exceptions_1 = require("./exceptions");
var lookupgenerators_1 = require("./lookupgenerators");
var lookupstatemachine_1 = require("./lookupstatemachine");
var modlservices_1 = require("./modlservices");
var moduleconfig_1 = require("./moduleconfig");
var numuri_1 = require("./numuri");
var resourceloader_1 = require("./resourceloader");
var num_easy_log_1 = require("num-easy-log");
exports.createClient = function (resolvers) { return new NumClientImpl(resolvers); };
exports.lookup = function (uri) {
    var numUri = numuri_1.parseNumUri(uri);
    var client = exports.createClient();
    var ctx = client.createContext(numUri);
    return client.retrieveNumRecord(ctx);
};
exports.createDefaultCallbackHandler = function () { return new DefaultCallbackHandler(); };
var DEFAULT_BASE_URL = 'https://modules.numprotocol.com/';
var DEFAULT_LANGUAGE = 'en';
var DEFAULT_COUNTRY = 'us';
var DEFAULT_LOCALE_FILE_NAME = 'en-us.json';
var DNS_REQUEST_TIMEOUT_MS = 500;
var expandedSchemaPathComponent = 'expanded';
var compactSchemaPathComponent = 'compact';
var ajv = new ajv_1.default({ strict: false });
ajv_formats_1.default(ajv);
var DEFAULT_RESOLVERS = [new dnsclient_1.DoHResolver('Cloudflare', 'https://cloudflare-dns.com/dns-query'), new dnsclient_1.DoHResolver('Google', 'https://dns.google.com/resolve')];
var DefaultCallbackHandler = (function () {
    function DefaultCallbackHandler() {
        this.location = null;
        this.result = null;
        this.errorCode = null;
    }
    DefaultCallbackHandler.prototype.setLocation = function (l) {
        this.location = l;
    };
    DefaultCallbackHandler.prototype.setResult = function (r) {
        this.result = r;
    };
    DefaultCallbackHandler.prototype.getLocation = function () {
        return this.location;
    };
    DefaultCallbackHandler.prototype.getResult = function () {
        return this.result;
    };
    DefaultCallbackHandler.prototype.setErrorCode = function (e) {
        this.errorCode = e;
    };
    DefaultCallbackHandler.prototype.getErrorCode = function () {
        return this.errorCode;
    };
    return DefaultCallbackHandler;
}());
exports.DefaultCallbackHandler = DefaultCallbackHandler;
var NumClientImpl = (function () {
    function NumClientImpl(resolvers) {
        this.schemaValidationIsDisabled = false;
        this.dnsServices =
            resolvers && resolvers.length > 0 ? dnsservices_1.createDnsServices(DNS_REQUEST_TIMEOUT_MS, resolvers) : dnsservices_1.createDnsServices(DNS_REQUEST_TIMEOUT_MS, DEFAULT_RESOLVERS);
        this.modlServices = modlservices_1.createModlServices();
        this.resourceLoader = resourceloader_1.createResourceLoader();
        this.configProvider = moduleconfig_1.createModuleConfigProvider(this.resourceLoader);
    }
    NumClientImpl.prototype.disableSchemaValidation = function () {
        this.schemaValidationIsDisabled = true;
    };
    NumClientImpl.prototype.setResourceLoader = function (loader) {
        this.resourceLoader = loader;
        this.configProvider = moduleconfig_1.createModuleConfigProvider(this.resourceLoader);
    };
    NumClientImpl.prototype.setenv = function (env) {
        this.setDnsEnv(env);
        this.setModuleEnv(env);
    };
    NumClientImpl.prototype.setDnsEnv = function (env) {
        lookupgenerators_1.setenvDomainLookups(env);
    };
    NumClientImpl.prototype.setModuleEnv = function (env) {
        this.resourceLoader.setenv(env);
    };
    NumClientImpl.prototype.setTimeoutMillis = function (t) {
        this.dnsServices.setTimeout(t);
    };
    NumClientImpl.prototype.createContext = function (numAddress) {
        try {
            return new context_1.Context(numAddress);
        }
        catch (e) {
            var err = e;
            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.errorCreatingContext, err.message);
        }
    };
    NumClientImpl.prototype.retrieveNumRecord = function (ctx, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var modl, json, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!true) return [3, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4, this.retrieveModlRecordInternal(ctx)];
                    case 2:
                        modl = _a.sent();
                        if (!modl) return [3, 4];
                        return [4, this.interpret(modl, ctx.numAddress.port, ctx.userVariables, ctx.targetExpandedSchemaVersion)];
                    case 3:
                        json = _a.sent();
                        if (json) {
                            num_easy_log_1.log.debug("json = " + json);
                            if (handler) {
                                handler.setResult(json);
                            }
                        }
                        else {
                            num_easy_log_1.log.debug('json = null');
                        }
                        return [2, json];
                    case 4:
                        handler === null || handler === void 0 ? void 0 : handler.setErrorCode(exceptions_1.NumProtocolErrorCode.noModlRecordFound);
                        return [2, null];
                    case 5:
                        e_1 = _a.sent();
                        if (e_1 instanceof exceptions_1.NumProtocolException) {
                            num_easy_log_1.log.error("NumProtocolException: " + e_1.errorCode + " : " + e_1.message);
                            handler === null || handler === void 0 ? void 0 : handler.setErrorCode(e_1.errorCode);
                            return [2, null];
                        }
                        else if (e_1 instanceof exceptions_1.NumMaximumRedirectsExceededException) {
                            num_easy_log_1.log.warn('Too many redirects. Aborting the lookup.');
                            ctx.result = null;
                            ctx.location = context_1.NumLocation.none;
                            handler === null || handler === void 0 ? void 0 : handler.setErrorCode(exceptions_1.NumProtocolErrorCode.tooManyRedirects);
                            return [2, null];
                        }
                        else if (e_1 instanceof exceptions_1.NumLookupRedirect) {
                            ctx.location = context_1.NumLocation.independent;
                            ctx.handleQueryRedirect(e_1.message);
                        }
                        else if (e_1 instanceof exceptions_1.NumLookupEmptyResult) {
                            num_easy_log_1.log.warn('Empty result');
                            ctx.result = null;
                            ctx.location = context_1.NumLocation.none;
                            handler === null || handler === void 0 ? void 0 : handler.setErrorCode(exceptions_1.NumProtocolErrorCode.noModlRecordFound);
                            return [2, null];
                        }
                        else if (e_1 instanceof exceptions_1.NumLookupBadDoHResponse) {
                            num_easy_log_1.log.warn('Bad DoH Service');
                            ctx.location = context_1.NumLocation.none;
                            handler === null || handler === void 0 ? void 0 : handler.setErrorCode(exceptions_1.NumProtocolErrorCode.badDoHResponse);
                            return [2, null];
                        }
                        else if (e_1 instanceof Error) {
                            num_easy_log_1.log.warn("Unhandled exception: " + e_1.message);
                            ctx.location = context_1.NumLocation.none;
                            handler === null || handler === void 0 ? void 0 : handler.setErrorCode(exceptions_1.NumProtocolErrorCode.noModlRecordFound);
                            handler === null || handler === void 0 ? void 0 : handler.setErrorCode(exceptions_1.NumProtocolErrorCode.internalError);
                            return [2, null];
                        }
                        return [3, 6];
                    case 6: return [3, 0];
                    case 7: return [2];
                }
            });
        });
    };
    NumClientImpl.prototype.retrieveModlRecord = function (ctx, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var modl, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!true) return [3, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4, this.retrieveModlRecordInternal(ctx)];
                    case 2:
                        modl = _a.sent();
                        if (!modl) return [3, 4];
                        return [4, this.interpret(modl, ctx.numAddress.port, ctx.userVariables, ctx.targetExpandedSchemaVersion)];
                    case 3:
                        _a.sent();
                        if (handler) {
                            handler.setResult(modl);
                        }
                        return [2, modl];
                    case 4: return [2, null];
                    case 5:
                        e_2 = _a.sent();
                        if (e_2 instanceof exceptions_1.NumProtocolException) {
                            if (handler) {
                                num_easy_log_1.log.error("NumProtocolException: " + e_2.errorCode + " : " + e_2.message);
                                handler.setErrorCode(e_2.errorCode);
                                return [2, null];
                            }
                        }
                        else if (e_2 instanceof exceptions_1.NumMaximumRedirectsExceededException) {
                            num_easy_log_1.log.warn('Too many redirects. Aborting the lookup.');
                            ctx.result = null;
                            ctx.location = context_1.NumLocation.none;
                            if (handler) {
                                handler.setErrorCode(exceptions_1.NumProtocolErrorCode.tooManyRedirects);
                            }
                            return [2, null];
                        }
                        else if (e_2 instanceof exceptions_1.NumLookupRedirect) {
                            ctx.location = context_1.NumLocation.independent;
                            ctx.handleQueryRedirect(e_2.message);
                        }
                        else if (e_2 instanceof Error) {
                            num_easy_log_1.log.warn("Unhandled exception: " + e_2.message);
                            if (handler) {
                                handler.setErrorCode(exceptions_1.NumProtocolErrorCode.internalError);
                            }
                            return [2, null];
                        }
                        return [3, 6];
                    case 6: return [3, 0];
                    case 7: return [2];
                }
            });
        });
    };
    NumClientImpl.prototype.retrieveModlRecordInternal = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var query, sm, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (ctx.location) {
                                    case context_1.NumLocation.independent:
                                        return [2, this.dnsQuery(ctx.queries.independentRecordLocation, ctx)];
                                    case context_1.NumLocation.hosted:
                                        return [2, this.dnsQuery(ctx.queries.hostedRecordLocation, ctx)];
                                    case context_1.NumLocation.populator:
                                        return [2, this.populatorQuery(ctx)];
                                    case context_1.NumLocation.none:
                                    default:
                                        return [2, false];
                                }
                                return [2];
                            });
                        }); };
                        sm = lookupstatemachine_1.createLookupLocationStateMachine();
                        _a.label = 1;
                    case 1:
                        if (!!sm.complete()) return [3, 3];
                        num_easy_log_1.log.info("Checking location: '" + ctx.location + "'");
                        return [4, query()];
                    case 2:
                        result = _a.sent();
                        ctx.location = sm.step(result);
                        return [3, 1];
                    case 3:
                        if (ctx.result) {
                            num_easy_log_1.log.info("Lookup result: '" + ctx.result + "', location: '" + ctx.location + "'");
                        }
                        else {
                            num_easy_log_1.log.info("Lookup result: 'null', location: '" + ctx.location + "'");
                        }
                        return [2, ctx.result];
                }
            });
        });
    };
    NumClientImpl.prototype.interpret = function (modl, moduleNumber, userVariables, targetExpandedVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonResult, moduleConfig, compactVersion, substitutionsData, schemaMapUrl, schemaMapResponse, expandedVersion;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jsonResult = this.modlServices.interpretNumRecord(modl);
                        num_easy_log_1.log.debug("Interpreter raw JSON result: " + JSON.stringify(jsonResult));
                        if (!(moduleNumber.n !== 0)) return [3, 13];
                        return [4, this.configProvider.getConfig(moduleNumber)];
                    case 1:
                        moduleConfig = _a.sent();
                        if (!moduleConfig) return [3, 12];
                        compactVersion = jsonResult['@v'] ? "" + jsonResult['@v'] : '1';
                        if (!(moduleConfig.compactSchema && !this.schemaValidationIsDisabled)) return [3, 3];
                        return [4, this.validateSchema(moduleNumber.n, compactSchemaPathComponent, compactVersion, jsonResult)];
                    case 2:
                        if (!(_a.sent())) {
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.compactSchemaError, 'The record does not match the compact schema');
                        }
                        return [3, 4];
                    case 3:
                        num_easy_log_1.log.info('Not configured to validate against the compact schema.');
                        _a.label = 4;
                    case 4:
                        substitutionsData = {};
                        if (!moduleConfig.substitutions) return [3, 6];
                        return [4, this.loadSubstitutionsFile(moduleConfig, userVariables)];
                    case 5:
                        substitutionsData = _a.sent();
                        if (!substitutionsData) {
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.substitutionsFileNotFoundError, "Unable to locate a substitutions file using " + JSON.stringify(userVariables));
                        }
                        _a.label = 6;
                    case 6: return [4, this.generateSchemaMapUrl(moduleConfig, compactVersion, targetExpandedVersion)];
                    case 7:
                        schemaMapUrl = _a.sent();
                        return [4, this.resourceLoader.load(schemaMapUrl)];
                    case 8:
                        schemaMapResponse = _a.sent();
                        if (schemaMapResponse && schemaMapResponse.data) {
                            jsonResult = object_unpacker_1.mapper.convert(substitutionsData, jsonResult, schemaMapResponse.data);
                            num_easy_log_1.log.debug("Object Unpacker JSON result: " + JSON.stringify(jsonResult));
                        }
                        else {
                            num_easy_log_1.log.error("Unable to load schema map defined in " + JSON.stringify(moduleConfig));
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.noUnpackerConfigFileFound, "Could not load the configured Unpacker config file: " + schemaMapUrl);
                        }
                        if (!(moduleConfig.expandedSchema && !this.schemaValidationIsDisabled)) return [3, 10];
                        if (!jsonResult['@version']) {
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.missingExpandedSchemaVersion, JSON.stringify(jsonResult));
                        }
                        expandedVersion = "" + jsonResult['@version'];
                        return [4, this.validateSchema(moduleNumber.n, expandedSchemaPathComponent, expandedVersion, jsonResult)];
                    case 9:
                        if (!(_a.sent())) {
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.expandedSchemaError, 'The record does not match the expanded schema');
                        }
                        return [3, 11];
                    case 10:
                        num_easy_log_1.log.info('Not configured to validate against the expanded schema.');
                        _a.label = 11;
                    case 11: return [3, 13];
                    case 12:
                        num_easy_log_1.log.error('No module config file available.');
                        throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.moduleConfigFileNotFound, "Unable to load the module config file for module " + moduleNumber.n + " ");
                    case 13: return [2, JSON.stringify(jsonResult)];
                }
            });
        });
    };
    NumClientImpl.prototype.dnsQuery = function (query, ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.dnsServices.getRecordFromDns(query, ctx.dnssec)];
                    case 1:
                        result = _a.sent();
                        if (result.length > 0 && /(^\d+\|.*)|(\d+\/\d+\|@n=\d+;.*)|(@n=\d+;.*)/.test(result)) {
                            ctx.result = result;
                            return [2, true];
                        }
                        return [2, false];
                }
            });
        });
    };
    NumClientImpl.prototype.populatorQuery = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var populatorLocation, result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        populatorLocation = ctx.queries.populatorLocation;
                        if (!populatorLocation) return [3, 5];
                        return [4, this.dnsServices.getRecordFromDns(populatorLocation, false)];
                    case 1:
                        result = _b.sent();
                        if (!result.includes('status_')) return [3, 2];
                        if (result.includes('code=1')) {
                            return [2, 1];
                        }
                        else if (result.includes('code=2')) {
                            return [2, 2];
                        }
                        else if (result.includes('code=3')) {
                            return [2, 3];
                        }
                        else {
                            return [2, false];
                        }
                        return [3, 5];
                    case 2:
                        if (!result.includes('error_')) return [3, 3];
                        return [2, false];
                    case 3:
                        _a = ctx;
                        return [4, this.interpret(result, ctx.numAddress.port, ctx.userVariables, ctx.targetExpandedSchemaVersion)];
                    case 4:
                        _a.result = _b.sent();
                        return [2, true];
                    case 5: return [2, false];
                }
            });
        });
    };
    NumClientImpl.prototype.validateSchema = function (moduleNumber, schemaType, version, json) {
        return __awaiter(this, void 0, void 0, function () {
            var schemaUrl, existingSchema, schema, msg, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schemaUrl = "" + DEFAULT_BASE_URL + moduleNumber + "/" + schemaType + "/v" + version + "/schema.json";
                        existingSchema = ajv.getSchema(schemaUrl);
                        if (!!existingSchema) return [3, 2];
                        return [4, this.resourceLoader.load(schemaUrl)];
                    case 1:
                        schema = _a.sent();
                        if (schema && schema.data) {
                            existingSchema = ajv.getSchema(schemaUrl) ? ajv.getSchema(schemaUrl) : ajv.compile(schema.data);
                        }
                        else {
                            msg = "Unable to load the JSON schema from : " + schemaUrl;
                            num_easy_log_1.log.error(msg);
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.schemaNotFound, msg);
                        }
                        _a.label = 2;
                    case 2:
                        if (!existingSchema) {
                            msg = "Cannot find the JSON schema at " + schemaUrl;
                            num_easy_log_1.log.error(msg);
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.schemaNotFound, msg);
                        }
                        if (existingSchema(json)) {
                            num_easy_log_1.log.info("JSON matches the schema at " + schemaUrl);
                            return [2, true];
                        }
                        else {
                            num_easy_log_1.log.error("Fails to match the JSON schema at " + schemaUrl + " - data: " + JSON.stringify(json));
                        }
                        return [2, false];
                }
            });
        });
    };
    NumClientImpl.prototype.loadSubstitutionsFile = function (moduleConfig, userVariables) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var subsFileName, subsFileResponse, country, language, localeFilename, fallbackLocale;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        subsFileName = '';
                        subsFileResponse = null;
                        if (!(moduleConfig.substitutionsType === moduleconfig_1.SubstitutionsType.locale)) return [3, 6];
                        country = (_a = userVariables.get('_C')) === null || _a === void 0 ? void 0 : _a.toString();
                        language = (_b = userVariables.get('_L')) === null || _b === void 0 ? void 0 : _b.toString();
                        if (!language) {
                            language = DEFAULT_LANGUAGE;
                        }
                        if (!country) {
                            country = DEFAULT_COUNTRY;
                        }
                        localeFilename = language + "-" + country + ".json";
                        subsFileName = "" + DEFAULT_BASE_URL + moduleConfig.moduleId.n + "/locales/" + localeFilename;
                        return [4, this.resourceLoader.load(subsFileName)];
                    case 1:
                        subsFileResponse = _c.sent();
                        if (!(!subsFileResponse || !subsFileResponse.data)) return [3, 5];
                        if (!(localeFilename === DEFAULT_LOCALE_FILE_NAME)) return [3, 2];
                        num_easy_log_1.log.debug("Unable to load substitutions file: " + subsFileName);
                        return [2, null];
                    case 2: return [4, this.generateFallbackLocaleFileName(moduleConfig, language)];
                    case 3:
                        fallbackLocale = _c.sent();
                        return [4, this.resourceLoader.load(fallbackLocale)];
                    case 4:
                        subsFileResponse = _c.sent();
                        if (!subsFileResponse || !subsFileResponse.data) {
                            num_easy_log_1.log.debug("Unable to load substitutions file: " + fallbackLocale);
                            return [2, null];
                        }
                        _c.label = 5;
                    case 5: return [3, 9];
                    case 6:
                        if (!(moduleConfig.substitutionsType === moduleconfig_1.SubstitutionsType.standard)) return [3, 8];
                        subsFileName = "" + DEFAULT_BASE_URL + moduleConfig.moduleId.n + "/substitutions.json";
                        return [4, this.resourceLoader.load(subsFileName)];
                    case 7:
                        subsFileResponse = _c.sent();
                        if (!subsFileResponse || !subsFileResponse.data) {
                            num_easy_log_1.log.debug("Unable to load substitutions file: " + subsFileName);
                            return [2, null];
                        }
                        return [3, 9];
                    case 8: throw new exceptions_1.NumNotImplementedException("Unknown substitutionsType value: " + JSON.stringify(moduleConfig.substitutionsType));
                    case 9: return [2, subsFileResponse.data];
                }
            });
        });
    };
    NumClientImpl.prototype.generateSchemaMapUrl = function (moduleConfig, compactVersion, targetExpandedVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var mapJsonUrl, mapJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapJsonUrl = "" + DEFAULT_BASE_URL + moduleConfig.moduleId.n + "/transformation/map.json";
                        return [4, this.resourceLoader.load(mapJsonUrl)];
                    case 1:
                        mapJson = _a.sent();
                        if (!mapJson || !mapJson.data) {
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.missingTransformationsMap, "No map.json available at " + mapJsonUrl);
                        }
                        return [2, exports.mapJsonToTransformationFileName(moduleConfig.moduleId.n, mapJson.data, compactVersion, targetExpandedVersion)];
                }
            });
        });
    };
    NumClientImpl.prototype.generateFallbackLocaleFileName = function (moduleConfig, lang) {
        return __awaiter(this, void 0, void 0, function () {
            var listJsonUrl, listJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        listJsonUrl = "" + DEFAULT_BASE_URL + moduleConfig.moduleId.n + "/locales/list.json";
                        return [4, this.resourceLoader.load(listJsonUrl)];
                    case 1:
                        listJson = _a.sent();
                        if (listJson && listJson.data) {
                            return [2, exports.findFirstWithSameLanguage(listJson.data, lang, moduleConfig)];
                        }
                        else {
                            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.missingLocalesList, "No list.json file found for module " + moduleConfig.moduleId.n + " at " + listJsonUrl);
                        }
                        return [2];
                }
            });
        });
    };
    return NumClientImpl;
}());
exports.mapJsonToTransformationFileName = function (module, mapJson, compactVersion, targetExpandedVersion) {
    var c = mapJson["compact-v" + compactVersion];
    var e = c["expanded-v" + targetExpandedVersion];
    if (e) {
        var transformationFileName = e['transformation-file'];
        if (transformationFileName) {
            return "" + DEFAULT_BASE_URL + module + "/transformation/" + transformationFileName;
        }
        else {
            throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.invalidTargetExpandedSchemaForModule, "Module: " + module + " has no target expanded schema v" + targetExpandedVersion + " configured for compact schema version v" + compactVersion);
        }
    }
    else {
        throw new exceptions_1.NumProtocolException(exceptions_1.NumProtocolErrorCode.invalidTargetExpandedSchemaForModule, "Module: " + module + " has no target expanded schema v" + targetExpandedVersion + " configured for compact schema version v" + compactVersion);
    }
};
exports.findFirstWithSameLanguage = function (listJson, lang, moduleConfig) {
    var found = listJson.find(function (v) { return v.startsWith(lang); });
    if (!found) {
        found = 'en-us';
    }
    return "" + DEFAULT_BASE_URL + moduleConfig.moduleId.n + "/locales/" + found + ".json";
};
//# sourceMappingURL=client.js.map